/**
 * Playready Key Message.
 *
 *
 * @beta
 */
export const PLAYREADY_KEY_MESSAGE = 'PlayReadyKeyMessage'
